import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateCategoryGroup({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    name,
    description,
    type,
  }: {
    name: string
    description: string
    type: 'expenses' | 'income'
  }) => {
    const response = await httpClient.post(
      `/team/transaction-category/group/${type}`,
      {
        name,
        description,
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Transaction category group created')
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
